const NS = 'TabDropdownBlock';
const CLS = 'tabDropdownBlock';

export class TabDropdownBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$select = this.$element.find(`.${CLS}-select`);
		this.$selectedItem = null;
		this.$tabItems = this.$element.find(`.${CLS}-tab`);

		this.initSelectedTab();
		this.$select.on('changed.bs.select', (_e, clickedIndex) => {
			let selectedKey = this.$select.children('option').eq(clickedIndex).val();
			this.selectTab(selectedKey);
		});

		$(window).resize(_.throttle(() => {
			this.setHeight();
		}, 250));
	}

	initSelectedTab() {
		let selectedKey = this.$element.attr('data-selected-key') || null;
		this.selectTab(selectedKey);
		this.setHeight();
	}

	setHeight() {
		let height = 0;

		this.$tabItems.each((index, element) => {
			if($(element).height() > height) {
				height = $(element).height();
			}
		});

		this.$tabItems.each((index, element) => {
			$(element).css({ minHeight: height });
		});
	}

	selectTab(dataKey) {
		this.$tabItems.each((index, element) => {
			if($(element).attr('data-key') === dataKey) {
				// Hide the previous item
				if(this.$selectedItem) {
					this.$selectedItem.css({ display: 'none' });
				}
				this.$selectedItem = $(element);
				this.$selectedItem.css({ display: 'flex' });
				this.$select.next('.dropdown-toggle').blur();
			}
		});
	}
}
